import { afterNextRender, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppStateService } from '../../services/app-state.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  public state = inject(AppStateService);
  private router = inject(Router);

  constructor() {
    afterNextRender(() => {
      if (this.isHomeRoute() || this.state.homeCmsLoaded()) {
        return;
      }
      this.state.fetchHomeCms();
    });
  }

  public goHome(): void {
    this.router.navigate(['/']);
    this.state.activeNavLink.set('home');
  }

  private isHomeRoute(): boolean {
    const path = this.router.url.split('?')[0].split('#')[0];
    if (path === '/' || path === '') {
      return true;
    }

    return this.router.isActive('/', {
      paths: 'exact',
      fragment: 'ignored',
      matrixParams: 'ignored',
      queryParams: 'ignored',
    });
  }
}
